export enum EModa {
  Presentiel = 'Presentiel',
  Blended = 'Blended',
  Elearning = 'Elearning'
}
export enum ETypeOption {
  CACES = 'CACES',
  HabilitatioElectirque = 'HabilitatioElectirque'
}
